import ky from 'ky'
import store from '../store'
import VueCookies from 'vue-cookies'
import { config } from '../config'
import { show } from './show'

const prefixHttp = process.env.NODE_ENV === 'production' ? '/' : '/api'
const http = ky.create({
  timeout: false,
  prefixUrl: prefixHttp,
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('X-Requested-With', 'XMLHttpRequest')
      },
    ],
    afterResponse: [
      async (request, options, response) => {
        if (response.status === 401) {
          console.error({ response })
          VueCookies.set(config.redirectCookie, location.pathname, '2m')
          await store.dispatch('user/logout')
          return Promise.reject(response)
        } else {
          return response
        }
      },
    ],
  },
})

async function showHttpError(e) {
  const errorResponse = await e.response.json()
  show.error(`${errorResponse.message}`)
}

async function showSuccess(message) {
  show.success(`${message}`)
}

export { prefixHttp, http, showHttpError, showSuccess }
